<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-collapse visible>
                    <p class="mb-3">
                        <label>
                            Por favor tener en cuenta que los reportes generados solo estarán
                            disponibles por 2 horas
                        </label>
                        <b-button
                            class="float-right"
                            variant="primary"
                            @click="reloadTickets"
                        >
                            Actualizar consulta
                        </b-button>
                    </p>
                    <b-table responsive
                             bordered
                             striped
                             hover
                             :items="informesProcesados"
                             :fields="columnas"
                             empty-text="No hay reportes para mostrar"
                             thead-tr-class="table-active"
                             show-empty
                    >
                        <template v-slot:cell(estado_procesamiento)="data">
                            <span v-if="!data.item.errores && data.item.estado_procesamiento">
                                {{ data.item.estado_procesamiento }}
                            </span>
                            <span v-else>
                                TERMINADO CON ERRORES <br/>
                                {{ data.item.errores }}
                            </span>
                        </template>

                        <template v-slot:head(opciones)="data">
                            <b-button
                                v-b-tooltip.hover.top="'Eliminar todos'"
                                variant="danger"
                                class="mx-1"
                                size="sm"
                                v-if="informesProcesados.some(i => i.estado_procesamiento === 'TERMINADO')"
                                @click="eliminarTodos"
                            >
                                <i class="el-icon-delete icon"/>
                            </b-button>
                        </template>


                        <template v-slot:cell(opciones)="data">
                            <b-button
                                variant="primary"
                                class="mx-1"
                                size="sm"
                                v-if="data.item.descargable"
                                @click="obtenerInventario(data.item.id)"
                                v-b-tooltip.hover
                                title="Descargar reporte"
                            >
                                <i class="fa fa-download icon"></i>
                            </b-button>
                            <b-button
                                variant="danger"
                                class="mx-1"
                                size="sm"
                                @click="eliminarReporte(data.item.id, data.item.id_empresa, data.item.empresa)"
                                v-if="data.item.estado_procesamiento == 'TERMINADO' && !data.item.errores"
                                v-b-tooltip.hover
                                title="Eliminar reporte"
                            >
                                <i class="el-icon-delete icon"/>
                            </b-button>
                        </template>
                    </b-table>
                </b-collapse>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import {mapActions, mapMutations, mapState} from 'vuex';
import loader from '../../containers/loader';

export default {
    name: 'tickets-agendados',
    data() {
        return {
            loading: false,
            columnas: [
                {
                    key: 'fecha_generacion',
                    label: 'Fecha de generación',
                    sortable: true,
                    tdClass: 'fechaGeneracion',
                },
                {
                    key: 'estado_procesamiento',
                    label: 'Estado de generación',
                    sortable: true,
                    tdClass: 'estadoGeneracion',
                },
                {
                    key: 'opciones',
                    label: 'Opciones',
                    sortable: true,
                    tdClass: 'opciones',
                    thClass: 'text-center',
                    thStyle: 'width: 105px'
                },
            ],
        };
    },
    components: {
        loader,
    },
    methods: {
        async eliminarReporte(id_proceso, id_empresa, empresa) {
            await Swal.fire({
                title: 'Eliminar reporte',
                text: `¿Desea eliminar el reporte?`,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Si, eliminar',
                cancelButtonColor: '#d33'
            })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        let data = {id: id_proceso, id_empresa: 0};
                        this.load(true);
                        await this.eliminarReporteAgendado(data);
                        await this.getTicketsReports();
                        this.load(false);
                    }
                });
        },
        async eliminarTodos() {
            await Swal.fire({
                title: 'Eliminar reportes',
                text: `¿Desea eliminar todos los reportes en estado "TERMINADO"?`,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Si, eliminar',
                cancelButtonColor: '#d33'
            })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        await this.eliminarTodosReportesAgendados();
                        await this.getTicketsReports();
                    }
                });
        },
        async reloadTickets() {
            await this.getTicketsReports();
        },
        async obtenerInventario(id) {
            await this.downloadReport(id);
            if (!this.error) {
                this.DescargarArchivo(this.tickets_report);
            }
        },
        async DescargarArchivo(tickets_report) {
            window.open(process.env.VUE_APP_API_URL + tickets_report);
        },
        ...mapActions('tickets', [
            'downloadReport',
            'getTicketsReports',
            'eliminarReporteAgendado',
            'eliminarTodosReportesAgendados'
        ]),
        ...mapMutations('dashboard', ['load']),
    },
    computed: {
        ...mapState('tickets', ['tickets_report', 'error','informesProcesados']),
    },
};
</script>
<style scoped>
.fechaSolicitud {
    width: 100px !important;
    max-width: 100px !important;
    min-width: 100px !important;
}

.fechaGeneracion {
    width: 100px !important;
    max-width: 100px !important;
    min-width: 100px !important;
}

.estadoGeneracion {
    width: 140px !important;
    max-width: 140px !important;
    min-width: 140px !important;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
